// ======================================================================
// File Name       : ImportThumbnailReduxForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Field } from 'redux-form';
import { FormControl, Col, Button, Form } from 'react-bootstrap';
import { VALIDATE_TYPE, ERROR_TYPE } from '../constants/index';
import * as MessageTemplate from '../constants/MessageTemplate';
import * as ValidateUtils from '../utils/ValidateUtils';
import { CHOSEN_THUMBNAIL_CONTENT } from '../constants/ItemConstant';

class FieldReduxForm extends React.Component {
  constructor(props) {
    super(props);
    this.REQUIRED = this.REQUIRED.bind(this);
    this.IMG_FILE = this.IMG_FILE.bind(this);
    this.THUMBNAIL_SIZE = this.THUMBNAIL_SIZE.bind(this);
  }
  REQUIRED(value, allValues, props) {
    if (allValues.imageFileSelectType === CHOSEN_THUMBNAIL_CONTENT.DEFAULT
      || allValues.imageFileSelectType === CHOSEN_THUMBNAIL_CONTENT.NOTHING) {
      return undefined;
    }
    if (!value) {
      this.errorType = ERROR_TYPE.EMPTY;
      return messageTemplate(this.props.label, MessageTemplate.W_REQUIRED);
    }

    return undefined;
  }
  IMG_FILE(value, allValues, props) {
    if (allValues.imageFileSelectType === CHOSEN_THUMBNAIL_CONTENT.DEFAULT
       || allValues.imageFileSelectType === CHOSEN_THUMBNAIL_CONTENT.NOTHING) {
      return undefined;
    }
    let isValid = true;
    let fileName = '.jpg';
    if (value && value[0] && value[0].name) {
      fileName = value[0].name;
    }
    isValid = ValidateUtils.validImageFile(fileName);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate(this.props.label, MessageTemplate.W_FILE_EXTENSION_INCORRECT);
    }
    return undefined;
  }
  THUMBNAIL_SIZE(value, allValues, props) {
    if (allValues.imageFileSelectType === CHOSEN_THUMBNAIL_CONTENT.DEFAULT
      || allValues.imageFileSelectType === CHOSEN_THUMBNAIL_CONTENT.NOTHING) {
      return undefined;
    }
    let isValid = true;
    let fileSize = 0;
    if (value && value[0] && value[0].size) {
      fileSize = value[0].size;
    }
    isValid = ValidateUtils.validThumbnailUploadSize(fileSize);
    if (!isValid) {
      this.errorType = ERROR_TYPE.ERROR;
      return messageTemplate('', MessageTemplate.MSG_THUMBNAIL_UPLOAD_SIZE_INVALID);
    }
    return undefined;
  }
  getValidationFunctions(validates) {
    const validateFunctions = [];
    for (const key in validates) {
      switch (validates[key]) {
        case VALIDATE_TYPE.REQUIRED: {
          validateFunctions.push(this.REQUIRED);
          break;
        }
        case VALIDATE_TYPE.IMG_FILE: {
          validateFunctions.push(this.IMG_FILE);
          break;
        }
        case VALIDATE_TYPE.THUMBNAIL_SIZE: {
          validateFunctions.push(this.THUMBNAIL_SIZE);
          break;
        }
        default: {
          break;
        }
      }
    }
    return validateFunctions;
  }

  render() {
    const {
      name,
      type,
      label,
      disabled,
      validates,
      value,
      data,
      fileName,
      className = '',
      fileSize,
      handleChangeOption,
      inputId,
      clearFileUpload,
    } = this.props;
    const validate = this.getValidationFunctions(validates);
    const fieldComponent = ThumbnailImport;
    return (
      <Field
        name={name}
        type={type}
        component={fieldComponent}
        label={label}
        validate={validate}
        disabled={disabled}
        data={data}
        value={value}
        errorType={this.errorType}
        fileName={fileName}
        className={className}
        fileSize={fileSize}
        handleChangeOption={handleChangeOption}
        inputId={inputId}
        onClickClear={clearFileUpload}
      />
    );
  }
}
function ThumbnailImport(props) {
  const {
    input: { disabled, errorType, ...inputProps },
    label,
    meta: { touched, error, submitFailed },
  } = props;
  inputProps.disabled = props.disabled;
  inputProps.errorType = props.errorType;
  const acceptType = 'image/*';
  return (
    <div>
      <Form.Group style={{ marginBottom: '0px' }}>
        <Col sm={7} className="col-sm-offset-3">
          <FormControl type="text" name="file_upload" readOnly value={props.fileName} id="fileNameUploadImageItem" />
        </Col>
        <Col sm={2} className="fileinput fileinput-new padding-left-15" data-provides="fileinput">
          <label
            htmlFor={props.inputId}
            className="btn btn-primary float-start button-form btn-96 margin-clear"
            disabled={inputProps.disabled}
          >
            {'選択'}
          </label>
          <FormControl
            id={props.inputId}
            type="file"
            className="hidden"
            accept={acceptType}
            onChange={inputProps.onChange}
            disabled={inputProps.disabled}
          />
        </Col>
        <Col sm={7} className="col-sm-offset-3">
          <ErrorMessage
            touched={touched}
            submitFailed={submitFailed}
            errorMessage={error}
            errorType={inputProps.errorType}
          />
        </Col>
        <Col sm={2} className="col-sm-offset-10 padding-left-15">
            <Button variant="danger" className="btn-96" disabled={props.fileName === '' ? true : false } onClick={props.onClickClear}>
              {'クリア'}
            </Button>
          </Col>
      </Form.Group>
    </div>
  );
}

function messageTemplate(label, msg) {
  return msg.replace('{0}', label);
}

function ErrorMessage(props) {
  const { errorMessage, errorType, touched, label, submitFailed } = props;
  return (
    <div style={{ marginTop: '5px' }}>
      {(touched || submitFailed) &&
        errorMessage && (
          <p
            className={getErrorClass(errorType)}
            style={{
              marginTop: '1px',
              fontWeight: 'bold',
              paddingTop: '7px',
              paddingBottom: '7px',
              marginBottom: '0px',
            }}
          >
            {label}
            {errorMessage}
          </p>
        )}
    </div>
  );
}

function getErrorClass(errorType) {
  switch (errorType) {
    case ERROR_TYPE.PRIMARY:
      return 'alert alert-info';
    case ERROR_TYPE.SUCCESS:
      return 'alert alert-success';
    case ERROR_TYPE.ERROR:
      return 'alert alert-danger';
    case ERROR_TYPE.WARNING:
      return 'alert alert-warning';
    case ERROR_TYPE.EMPTY:
      return 'alert alert-danger';
    default:
      return '';
  }
}

export default FieldReduxForm;
